import { render, staticRenderFns } from "./ChallengeReceivedModal.vue?vue&type=template&id=b10ef3a0"
import script from "./ChallengeReceivedModal.vue?vue&type=script&lang=js"
export * from "./ChallengeReceivedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports